import { __awaiter } from "tslib";
import { isNotReadyOrFailedToLoad, LoadedState, ReadyState, waitFor } from "../shared/index.js";
const state = {
    loadedState: LoadedState.NOT_LOADED,
    readyState: ReadyState.NOT_READY
};
let onReadyResolver;
const onReadyPromise = new Promise((resolve) => {
    onReadyResolver = resolve;
});
const waitForReadyOrTimeout = () => Promise.race([waitFor(2000), onReadyPromise]);
const onReady = () => {
    state.readyState = ReadyState.READY;
    onReadyResolver();
};
const onLoadedStateChanged = (loadedState) => {
    state.loadedState = loadedState;
};
const ensureLoadedAndGetData = (defaultValue, getData, retryLoading) => {
    if (state.loadedState === LoadedState.FAILED_TO_LOAD_IN_BROWSER) {
        retryLoading === null || retryLoading === void 0 ? void 0 : retryLoading();
        return Promise.resolve(defaultValue);
    }
    if (state.readyState === ReadyState.NOT_READY) {
        return waitForReadyOrTimeout().then(() => {
            if (state.readyState === ReadyState.NOT_READY) {
                return Promise.resolve(defaultValue);
            }
            return getData();
        });
    }
    return getData();
};
/*
    deferred will only be called if the sdk loading is in progress, or failed to load
    in such case, it will start listening on the onReadyPromise immediately, to assign the deferred service ASAP
    instead of actually doing it during the get call.
*/
const deferred = (defaults, retryLoading) => ({
    get: ({ tag, name }) => __awaiter(void 0, void 0, void 0, function* () { return ensureLoadedAndGetData(defaults[name], () => pulse.settings.get(tag, name), retryLoading); }),
    getSegments: () => __awaiter(void 0, void 0, void 0, function* () { return ensureLoadedAndGetData([], () => pulse.settings.getSegmentsIds(), retryLoading); })
});
const initRemoteSettings = (config, retryLoading) => {
    if (isNotReadyOrFailedToLoad(state.readyState, state.loadedState)) {
        return deferred(config.defaults || {}, retryLoading);
    }
    return {
        get: ({ tag, name }) => pulse.settings.get(tag, name),
        getSegments: () => pulse.settings.getSegmentsIds()
    };
};
export { initRemoteSettings, state as settingsState, onReady as onSettingsReady, onLoadedStateChanged as onSettingsLoadingStateChanged };
//# sourceMappingURL=settings.service.js.map